<template>
  <div class="rd-fbar fin-bar" :class="{ 'fin-bar--compact': compact }">
    <ui-segment v-if="!compact" :value="activeKey" :options="quickOptions" :label="$t('finance_period_label')" @input="pickQuick" />

    <v-menu v-model="menu" :close-on-content-click="false" offset-y bottom nudge-bottom="6" min-width="auto">
      <template #activator="{ on, attrs }">
        <button type="button" class="ui-btn" :class="{ 'is-accent': !activeKey }" v-bind="attrs" v-on="on">
          <v-icon size="16">mdi-calendar-range</v-icon>
          <span>{{ compact || !activeKey ? label : $t("finance_shell.dates") }}</span>
          <v-icon size="16">mdi-menu-down</v-icon>
        </button>
      </template>
      <div class="fin-pop">
        <div v-if="compact" class="fin-pop__presets">
          <button v-for="preset in presets" :key="preset.key" type="button" class="fin-pop__preset" :class="{ 'is-on': activeKey === preset.key }" @click="pickPreset(preset)">
            <span>{{ $t(`finance_period_${preset.key}`) }}</span>
            <small>{{ range(preset) }}</small>
          </button>
        </div>
        <v-date-picker v-model="draft" range no-title :first-day-of-week="1" :locale="locale" color="#c2410c" @input="onDraft" />
        <p class="fin-pop__hint">{{ draft.length === 1 ? $t("report_mobile.pick_end_date") : $t("finance_shell.pick_dates") }}</p>
      </div>
    </v-menu>

    <span v-if="!compact" class="fin-range">{{ label }}</span>
  </div>
</template>

<script>
import { formatRange } from "@/components/report/shared/periods";
import { findPresetKey } from "../financeQuery";

/**
 * Zajednička traka perioda Zarade i Transakcija: brzi izbori (ovaj mjesec, prošli, 30 dana, 90 dana, godina) i izbor
 * datuma. Na užem prikazu (telefon) je samo dugme sa trenutnim periodom, a izbori su u iskačućem prozoru.
 * Ne drži izbor: dobija period i javlja promjenu (ljuska ga upisuje u adresu).
 */
export default {
  name: "FinancePeriodBar",
  props: {
    from: { type: String, required: true },
    to: { type: String, required: true },
    presets: { type: Array, default: () => [] },
    compact: { type: Boolean, default: false },
  },
  data: () => ({ menu: false, draft: [] }),
  computed: {
    quickOptions() {
      return this.presets.map((preset) => ({ value: preset.key, label: this.$t(`finance_period_${preset.key}`) }));
    },
    activeKey() {
      return findPresetKey(this.presets, this.from, this.to);
    },
    label() {
      return formatRange(this.from, this.to);
    },
    locale() {
      const config = this.getCurrentLanguageConfig ? this.getCurrentLanguageConfig() : null;
      return (config && config.locale) || "sr-RS";
    },
  },
  watch: {
    menu(open) {
      if (open) {
        this.draft = [this.from, this.to];
      }
    },
  },
  methods: {
    pickQuick(key) {
      const preset = this.presets.find((item) => item.key === key);
      if (preset) {
        this.$emit("period", { from: preset.from, to: preset.to });
      }
    },
    range(preset) {
      return formatRange(preset.from, preset.to);
    },
    pickPreset(preset) {
      this.$emit("period", { from: preset.from, to: preset.to });
      this.menu = false;
    },
    onDraft(dates) {
      if (dates.length < 2) {
        return;
      }
      const [from, to] = [...dates].sort();
      this.$emit("period", { from, to });
      this.menu = false;
    },
  },
};
</script>
